import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import StatisticsContainer from "../../../../Components/Cards/StatisticsCardContainer";
import {
  getTenderList,
  tenderNr,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import Layout from "../../../../Layout/Layout";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import SupplierConstants from "../../../../common/SupplierConstants";
import PurchaseGCreateModal from "./PurchaseGCreateModal";
const PurchaseGroupList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Tender");
  localStorage.setItem("submenu", "Tender List");
  let tenderData = useSelector((state) => state?.purchasing?.tender);
  let tenderTable = useSelector(
    (state) => state?.purchasing?.tender.pagination,
  ); // User Details from Store
// eslint-disable-next-line
  const datas = [
  {
    documentNumber: "PD-1001",
    plantCode: "PLT001",
    plantDescription: "Manufacturing Plant",
    companyCode: "CMP01",
    companyName: "Veer",
  },
  {
    documentNumber: "PD-1002",
    plantCode: "PLT002",
    plantDescription: "Assembly Unit",
    companyCode: "CMP02",
    companyName: "Global Industries",
  },
  {
    documentNumber: "PD-1003",
    plantCode: "PLT003",
    plantDescription: "Packaging Plant",
    companyCode: "CMP03",
    companyName: "Sunrise Pvt Ltd",
  },
  {
    documentNumber: "PD-1004",
    plantCode: "PLT004",
    plantDescription: "Processing Unit",
    companyCode: "CMP04",
    companyName: "GreenField Corp",
  },
  {
    documentNumber: "PD-1005",
    plantCode: "PLT005",
    plantDescription: "Distribution Center",
    companyCode: "CMP05",
    companyName: "NextGen Logistics",
  },
];
 // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  // eslint-disable-next-line
  const [filteredData, setFilteredData] = useState([]);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(false);
  const showAddProduct = () => {
    setModalShowAddProduct(true);
  };
  const hideModal = () => {
    setModalShowAddProduct(false);
  };

  useEffect(() => {
    if (!showStats) {
      setFilteredData(tenderData.data);
    }
  }, [showStats, tenderData]);

  const handleChartClick = () => {
    setShowStats((prev) => !prev);
  };

  useEffect(() => {
    setData(tenderData?.data || []);
  }, [tenderData]);

  useEffect(() => {
    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  // const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getNewPerPage, setNewPerPage] = useState(10);
   // eslint-disable-next-line no-unused-vars
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const loadInitialTenderData = async () => {
    setData(tenderData?.data);
  };

  useEffect(() => {
    loadInitialTenderData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getTenderList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [chatId, setChatId] = useState(null); 
  const columns = [
    {
      name: "Purchase Document Nr",
      selector: (row) => row.documentNumber,
      width: "180px",
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailTenderNr(row.documentNumber)}
        >
          {row.documentNumber}
        </button>
      ),
    },
    {
      name: "Purchase Org Code",
      selector: (row) => row.plantCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Purchase Group Description",
      selector: (row) => row.plantDescription,
      sortable: true,
      width: "200px",
    },
    
  ];
  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getTenderList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };


   // eslint-disable-next-line no-unused-vars
  const detailTenderNr = (rfxNr) => {
    dispatch(tenderNr(rfxNr));
    navigate(SupplierConstants.TENEDER_DETAILS);
  };

  const loadInitialData = () => {
    setData(tenderData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getTenderList(obj));
    // dispatch(getTenderList({}));
    setData(tenderData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "TenderDocumentList",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getTenderList(obj));
    setData(tenderData?.data);
  };

  useEffect(() => {
    loadInitialData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenderData]);

  // Common Search Function on button
   // eslint-disable-next-line no-unused-vars
  const handleSearchFuncApi = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getTenderList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Purchase Organization Group</h2>
                <p className="subText">Lists of Plant Org Group and details</p>
              </Col>
              {/* <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col> */}
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>

            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}

                fetchFunction={ItemService.getTenderList}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            <hr />

            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateQueryV1}
                  keyName="tenderHeaderStatus"
                  paginatedList={tenderData.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="TenderDocumentList"
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PL</span>
                    </Col>
                    <Col xs={12} md={5} lg={5}>
                      <span className="headerTitle">PL List</span>
                      <span className="subHeaderTitle">
                        View of Purchase Org Details and Status{" "}
                      </span>
                    </Col>
                    <Col xs={2} md={2} lg={2} className="ms-auto">
                      <button
                        className="btnTable "
                        // onClick={() => createTender()}
                         onClick={showAddProduct}
                      >
                        <i className="bi bi-plus-lg"></i> Create Purchase Group
                      </button>
                    </Col>
                    <Col xs="auto" md="auto" lg="auto">
                      <CommonFillter onChartClick={handleChartClick} />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3]}
                        leftOffsets={[0, 120]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // columns={tendorColum}
                          // data={filteredData}
                          // data={datas}
                          progressPending={tenderData?.status}
                          paginationRowsPerPageOptions={
                            SupplierConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={tenderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
      <PurchaseGCreateModal
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        // dropdownData={getAccountGroup}
        // onSuccess={refreshCatalogList}
      />
    </main>
  );
};

export default PurchaseGroupList;
